// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import head from "vue-head";
import App from "@/App";
import router from "@/router";
import store from "@/store";
import i18n from "@/locales";
import Vuelidate from "vuelidate";
import { HTTP } from "@/helpers/http-common";
import VueBreadcrumbs from "vue-breadcrumbs";
import VueSweetalert2 from "vue-sweetalert2";
import { validateCheckListAfterRefresh } from "@/helpers/app-refresh-check-list";
import VueUserPermissions from "@/plugins/vue-user-permissions";
import Bitacora from "@/plugins/bitacora";
import IdleVue from "idle-vue";
import vuetify from "@/plugins/vuetify";
import VueMask from "v-mask";
import FilePond from "@/plugins/filepond";
import VueCircleSlider from "vue-circle-slider";
import Croppa from "vue-croppa";
import Vuebar from "vuebar";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCoffee } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import "@fortawesome/fontawesome-free/css/all.css";
import "@mdi/font/css/materialdesignicons.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@/assets/css/motionCaptcha.min.css";
import "@/assets/css/animate.css";
import "vue-croppa/dist/vue-croppa.css";

/** Event Bus Application */
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";

Vue.config.productionTip = false;
Vue.config.devtools = true;

// Add plugins
Vue.use(head);
Vue.use(Vuelidate);
Vue.use(VueCircleSlider);
Vue.use(VueBreadcrumbs, {
  template: `<ul class="breadcrumb v-breadcrumbs py-4 px-4 subheading theme--light" v-if="$breadcrumbs.length">
    <li v-for="(crumb, key) in $breadcrumbs" :key="key"><router-link class="v-breadcrumbs__item" style="color: gray;" :to="linkProp(crumb)" >{{ crumb | crumbText }}</router-link></li>
    </ul>`
});

Vue.use(VueSweetalert2);
Vue.use(VueUserPermissions, { router, store, strict: true, defaultRoute: "Feeds" });
Vue.use(Bitacora, router);

Vue.use(Vuebar);
Vue.use(VueMask);

// Tiempo de sesión, con o sin actividad
Vue.use(IdleVue, {
  eventEmitter: new Vue()
  , idleTime: 100000 * 60
});

Vue.use(Croppa, { componentName: "croppa" });
library.add(faCoffee);

Vue.component("FontAwesomeIcon", FontAwesomeIcon);

/* eslint-disable no-new */
export default new Vue({
  el: "#app"
  , components: {
    App
    , FilePond
  }
  // localStorage
  , beforeCreate() {
    validateCheckListAfterRefresh(this.$store, HTTP, this.$userPermission);
  }
  , router
  , store
  , i18n
  , vuetify
  // Validación de inactividad.
  , onIdle() {
    // Valida Sesión
    if (this.$store.getters.getUserIsAuthenticated) {
      const { username } = this.$store.getters.getUserData;
      EventBus.$emit(events.SESSION_TIME_FINISHED, { username });
    }
  }
  , onActive() {}
  , template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js